<template>
    <b-container fluid class="animated fadeIn">
        <h1>Incluir / Alterar Procurador</h1>
        <b-card>
            <b-row>
                <b-col xs="12" sm="12" md="8" lg="8" xl="8">
                    <b-form-group label="Nome: *" label-for="nome" class="text-label">
                        <b-form-input 
                            name="nome"
                            v-model="procurador.nome" 
                            type="text" 
                            maxlength="90"
                            v-validate="{ required: true }" />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group label="Número CPF: *" label-for="cpf" class="text-label">
                        <b-form-input 
                            name="cpf"
                            v-model="procurador.cpf" 
                            type="text" 
                            maxlength="14"
                            v-validate="{ required: true }"
                            v-mask="['###.###.###-##']" />
                    </b-form-group>
                </b-col>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group label="Chave PROJUDI:" label-for="chaveProjudi" class="text-label">
                        <b-form-input 
                            name="chaveProjudi"
                            v-model="procurador.chaveProjudi" 
                            type="text"
                            maxlength="20"
                            style="text-transform: uppercase" />
                    </b-form-group>
                </b-col>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group label="Chave EPROC:" label-for="chaveEproc" class="text-label">
                        <b-form-input 
                            name="chaveEproc"
                            v-model="procurador.chaveEproc" 
                            type="text"
                            maxlength="20"
                            style="text-transform: uppercase" />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group label="Número OAB: *" label-for="numeroOab" class="text-label">
                        <b-form-input 
                            name="numeroOab"
                            v-model="procurador.numeroOab" 
                            type="number" 
                            maxlength="6"
                            v-validate="{ required: true, max: 6 }" />
                    </b-form-group>
                </b-col>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group label="UF OAB: *" label-for="ufOAB" class="text-label">
                        <multiselect
                            name="ufOAB"
                            v-model="procurador.ufOAB"
                            :show-labels="false"
                            :options="dados.ufs"
                            :multiple="false"
                            :close-on-select="true"
                            :clear-on-select="true"
                            :preserve-search="false"
                            placeholder="Selecione"
                            track-by="sigla"
                            label="sigla"
                            v-validate="{ required: true }"
                        >
                        </multiselect>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group label="Usuário: *" label-for="usuario" class="text-label">
                        <multiselect
                            name="usuario"
                            v-model="procurador.usuario"
                            :show-labels="false"
                            :options="dados.usuarios"
                            :multiple="false"
                            :close-on-select="true"
                            :clear-on-select="true"
                            :preserve-search="false"
                            placeholder="Selecione"
                            track-by="codUsuario"
                            label="nomeUsuario"
                            v-validate="{ required: true }"
                        >
                        </multiselect>
                    </b-form-group>
                </b-col>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group label="Grupo de Trabalho:" label-for="grupoTrabalho" class="text-label">
                        <multiselect
                            name="grupoTrabalho"
                            v-model="procurador.grupoTrabalho"
                            :show-labels="false"
                            :options="dados.grupoTrabalho"
                            :multiple="false"
                            :close-on-select="true"
                            :clear-on-select="true"
                            :preserve-search="false"
                            placeholder="Selecione"
                            track-by="id"
                            label="nome"
                        >
                        </multiselect>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col xs="12" sm="12" md="2" lg="2" xl="2">
                    <b-form-group label="CEP: *" label-for="cep" class="text-label">
                        <b-form inline>
                            <b-form-input 
                                name="cep"
                                v-model="procurador.cep" 
                                type="text" 
                                maxlength="9"
                                v-mask="['#####-###']"
                                v-validate="{ required: true, min: 9 }"
                                @keyup="buscarCep()"
                                :disabled="inSearchCEP" />
                                <b-spinner class="ml-3" v-show="inSearchCEP" small label="Buscando cep..." type="grow"></b-spinner>
                        </b-form>
                    </b-form-group>
                </b-col>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group label="Última Sincronização de Agenda:" label-for="ultimaSyncAgenda" class="text-label">
                        <b-form-input 
                            name="ultimaSyncAgenda"
                            v-model="procurador.dataHoraUltimaSincronizacaoFormatada" 
                            type="text" 
                            :disabled="true" />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col xs="12" sm="12" md="6" lg="6" xl="6">
                    <b-form-group label="Logradouro: *" label-for="logradouro" class="text-label">
                        <b-form-input 
                            name="logradouro"
                            v-model="procurador.logradouro" 
                            type="text" 
                            maxlength="100"
                            v-validate="{ required: true }" />
                    </b-form-group>
                </b-col>
                <b-col xs="12" sm="12" md="2" lg="2" xl="2">
                    <b-form-group label="Número:" label-for="numeroLogradouro" class="text-label">
                        <b-form-input 
                            name="numeroLogradouro"
                            v-model="procurador.numeroLogradouro" 
                            type="text" 
                            v-mask="['##########']"
                            maxlength="10" />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group label="Complemento:" label-for="complemento" class="text-label">
                        <b-form-input 
                            name="complemento"
                            v-model="procurador.complemento" 
                            type="text" 
                            maxlength="30" />
                    </b-form-group>
                </b-col>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group label="Bairro:" label-for="bairro" class="text-label">
                        <b-form-input 
                            name="bairro"
                            v-model="procurador.bairro" 
                            type="text" 
                            maxlength="50" />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group label="E-mail: *" label-for="email" class="text-label">
                        <b-form-input 
                            name="email"
                            v-model="procurador.email" 
                            type="text" 
                            maxlength="60"
                            v-validate="'required|email'"/>
                    </b-form-group>
                </b-col>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group label="Telefone Fixo: *" label-for="telefoneFixo" class="text-label">
                        <b-form-input 
                            name="telefoneFixo"
                            v-model="procurador.telefoneFixo" 
                            v-mask="['(##) ####-####']"
                            type="text"
                            v-validate="{ required: true, min: 14 }" />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group label="Telefone Celular:" label-for="telefoneCelular" class="text-label">
                        <b-form-input 
                            name="telefoneCelular"
                            v-model="procurador.telefoneCelular" 
                            v-mask="['(##) #####-####']"
                            type="text"
                            v-validate="{ min: 14 }" />
                    </b-form-group>
                </b-col>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group label="Assessor:" label-for="assessores" class="text-label">
                        <multiselect
                            name="assessores"
                            v-model="procurador.assessores"
                            :show-labels="false"
                            :options="dados.assessores"
                            :multiple="true"
                            :close-on-select="true"
                            :clear-on-select="true"
                            :preserve-search="false"
                            placeholder="Selecione"
                            track-by="codUsuario"
                            label="nomeUsuario"
                        >
                        </multiselect>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group
                        label="Situação: *"
                        label-for="ativo">
                        <b-form-checkbox switch v-model="procurador.indAtivo">{{ procurador.indAtivo ? 'Ativo' : 'Inativo'}}</b-form-checkbox>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-button variant="primary" @click.prevent="salvar" :disabled="inSave">
                        <i class="fa fa-save"></i> Salvar
                    </b-button>
                    <b-button variant="primary" class="ml-2" @click="voltar">
                        <i class="fa fa-reply"></i> Voltar
                    </b-button>
                </b-col>
            </b-row>
        </b-card>
    </b-container>
</template>

<script>
import axios from 'axios'
import formatarMixins from '../../../mixins/formatarMixins'

export default {
    name: 'ManterProcuradorEditar',
    mixins: [ formatarMixins ],
    data() {
        return {
            inSearchCEP: false,
            inSave: false,
            procurador: {
                nome: null,
                cpf: null,
                chaveProjudi: null,
                chaveEproc: null,
                numeroOab: null,
                ufOAB: null,
                usuario: null,
                cep: null,
                logradouro: null,
                numeroLogradouro: null,
                complemento: null,
                bairro: null,
                email: null,
                telefoneFixo: null,
                telefoneCelular: null,
                indAtivo: true,
                grupoTrabalho: null,
                assessores: null
            },
            dados: {
                usuarios: [],
                ufs: [],
                grupoTrabalho: [],
                assessores: []
            },
        }
    },
    methods: {

        salvar() {
            this.inSave = true
            this.$validator.validateAll().then( async (result) => {
                if (!result) {
                    this.$store.commit("setMessages", { message: 'Atenção', variant: 'danger' , errors: ['Favor preencher os campos obrigatórios (*)'] });
                    this.inSave = false
                    window.scrollTo(0,0);
                    return
                }

                const urlApi = process.env.VUE_APP_ROOT_API
                const token = JSON.parse(this.$store.getters.getUser).access_token

                const procurador = {
                    ...this.procurador
                }

                await axios.post(`${urlApi}/v1/procurador/salvar`, procurador, {
                    headers: {
                        'Authorization': token,
                        'Content-Type': 'application/json',
                    }
                })
                .then(response => {
                    if(response.data) {
                        this.$store.commit("setMessages", { message: 'Atenção', variant: 'danger' , errors: [`${response.data.message}`] });
                        window.scrollTo(0,0);
                        return
                    }
                    this.$store.commit("setMsgProcurador", 'Operação realizada com sucesso!!!')
                    this.$store.commit("setProcurador", null);
                    this.$router.push({ path: '/procurador' })
                }).catch((error) => {
                    this.exibirErro(error)
                }).finally(() => {
                    this.inSave = false
                })
            })
        },

        voltar() {
            this.$store.commit("setProcurador", null);
            this.$router.push({ path: '/procurador' })
        },

        async buscarCep() {
            if(this.procurador.cep) {
                if(this.procurador.cep.toString().length === 9) {
                    this.inSearchCEP = true

                    const urlApi = process.env.VUE_APP_ROOT_API
                    const token = JSON.parse(this.$store.getters.getUser).access_token
                    const cepNumeros = this.onlyNumber(this.procurador.cep)

                    axios.get(`${urlApi}/neocep/enderecamento/v3/endereco/${cepNumeros}/${2}`, {
                        headers: {
                            'Authorization': token,
                            'Content-Type': 'application/json',
                        }
                    })
                    .then(response => {
                        this.procurador.logradouro = response.data.endereco;
                        this.procurador.numeroLogradouro = response.data.numeroEndereco;
                        this.procurador.complemento = response.data.complemento
                        this.procurador.bairro = response.data.bairro
                    }).finally(() => {
                        this.inSearchCEP = false
                    })
                }
            }
        },

        onlyNumber(string) 
        {
            var numsStr = string.replace(/[^0-9]/g,'');
            return parseInt(numsStr);
        },

        /**
         * Exibe erros dos catch
         */
        exibirErro(error) {
            this.$store.commit("setMessages", { message: 'Erro!', errors: [error] });
        },

        /**
         * Listar UFs
         */
        async listarUfs() {
            const urlApi = process.env.VUE_APP_ROOT_API
            const token = JSON.parse(this.$store.getters.getUser).access_token

            axios.get(`${urlApi}/v1/procurador/listarUfs`, {
                headers: {
                    'Authorization': token,
                    'Content-Type': 'application/json',
                }
            })
            .then(response => {
              this.dados.ufs = response.data
            })
        },

        /**
         * Listar Usuarios
         */
        async listarUsuarios() {
            const urlApi = process.env.VUE_APP_ROOT_API
            const token = JSON.parse(this.$store.getters.getUser).access_token

            axios.get(`${urlApi}/v1/procurador/listarUsuarios`, {
                headers: {
                    'Authorization': token,
                    'Content-Type': 'application/json',
                }
            })
            .then(response => {
              this.dados.usuarios = response.data
            })
        },

        /**
         * Listar GrupoTrabalho
         */
         async listarGrupoTrabalho() {
            const urlApi = process.env.VUE_APP_ROOT_API
            const token = JSON.parse(this.$store.getters.getUser).access_token

            axios.get(`${urlApi}/v1/grupotrabalho/listarAtivos`, {
                headers: {
                    'Authorization': token,
                    'Content-Type': 'application/json',
                }
            })
            .then(response => {
              this.dados.grupoTrabalho = response.data
            })
        },

        /**
         * Listar Assessores
         */
         async listarAssessores() {
            const urlApi = process.env.VUE_APP_ROOT_API
            const token = JSON.parse(this.$store.getters.getUser).access_token

            const params = {
                grupoSentinela: 'PGEPROAJU-AGENDAPRAZO-ASSES'
            }

            axios.get(`${urlApi}/v1/usuario`, {
                params: params,
                headers: {
                    'Authorization': token,
                    'Content-Type': 'application/json',
                }
            })
            .then(response => {
              this.dados.assessores = response.data
            })
        },

        async obterProcurador(codProcurador) {
            const urlApi = process.env.VUE_APP_ROOT_API
            const token = JSON.parse(this.$store.getters.getUser).access_token

            await axios.post(`${urlApi}/v1/procurador/obter`, codProcurador, {
                headers: {
                    'Authorization': token,
                    'Content-Type': 'application/json',
                }
            })
            .then(response => {
                this.procurador = response.data
                this.procurador.dataHoraUltimaSincronizacaoFormatada = formatarMixins.methods.formatarDataHora(this.procurador.dataHoraUltimaSincronizacao)
            }).catch((error) => {
                this.exibirErro(error)
            })
        },
    },
    mounted() {
        this.$store.commit("setMessages", {});

        const procuradorEdicao = this.$store.getters.getProcurador;
        if(procuradorEdicao) {
            this.obterProcurador(procuradorEdicao.codProcurador)
        }

        this.listarUfs()
        this.listarUsuarios()
        this.listarGrupoTrabalho()
        this.listarAssessores()
    }
    
}
</script>

<style scoped>


</style>
